import React, { useState } from 'react';
import { Button, Input } from '@lognai/synapse-design-system-v2';

export interface ChatComposerProps {
  onSubmit: (text: string) => void;
  disabled?: boolean;
}

export const ChatComposer: React.FC<ChatComposerProps> = ({ onSubmit, disabled }) => {
  const [value, setValue] = useState('');
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        const trimmed = value.trim();
        if (!trimmed || disabled) return;
        onSubmit(trimmed);
        setValue('');
      }}
      style={{ padding: '10px 14px', borderTop: '1px solid var(--border)', display: 'flex', gap: 8 }}
    >
      <Input
        type="text"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder="Ask LognAI…"
        disabled={disabled}
        aria-label="Message"
        className="flex-1 text-sm"
      />
      <Button
        type="submit"
        variant="secondary"
        size="sm"
        disabled={disabled || value.trim().length === 0}
      >
        Send
      </Button>
    </form>
  );
};
